var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.66667V40H56V6.66667M40 49.3333L32 57.3333L24 49.3333M32 40V57.3333",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 28C37.4 28 42.2894 25.3333 46.6667 20C42.2894 14.6667 37.4 12 32 12C26.6 12 21.7107 14.6667 17.3334 20C21.7107 25.3333 26.6 28 32 28Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 5.33333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24C33.0609 24 34.0783 23.5786 34.8284 22.8284C35.5786 22.0783 36 21.0609 36 20C36 18.9391 35.5786 17.9217 34.8284 17.1716C34.0783 16.4214 33.0609 16 32 16C30.9391 16 29.9217 16.4214 29.1716 17.1716C28.4214 17.9217 28 18.9391 28 20C28 21.0609 28.4214 22.0783 29.1716 22.8284C29.9217 23.5786 30.9391 24 32 24Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewers);
export default __webpack_public_path__ + "static/media/viewers.abf6f42e0a90baaba5358967e2ab42dd.svg";
export { ForwardRef as ReactComponent };